import Button from "@/Components/Button";
import Input from "@/Components/Input";
import Label from "@/Components/Label";
import { stringToSlug } from "@/helpers/string";
import { useForm } from "@inertiajs/inertia-react";
import React, { useEffect, useState } from "react";

const Create = ({ ...props }) => {

    const [placeholderName, setPlaceholderName] = useState('');

    const { data, setData, post } = useForm({
        'name': '',
        'label': ''
    });

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value);
    };

    const submit = (event) => {
        event.preventDefault();

        post(route('roles.store'));
    }

    useEffect(() => {
        const slug = stringToSlug(data.label, '_');
        setPlaceholderName(slug)
    }, [data.label]);

    useEffect(() => {
        const slug = stringToSlug(data.name, '_');
        setData('name', slug);
    }, [data.name])

    return (
        <form {...props} onSubmit={submit}>
            <div className="grid grid-cols-2 gap-4 w-full mb-4">
                <div>
                    <Label forInput="label" value="Nombre" />
                    <Input name="label" handleChange={onHandleChange} value={data.label} className="w-full" />
                </div>
                <div>
                    <Label forInput="name" value="Identificador" />
                    <Input
                        onDoubleClick={() => {
                            if (!data.name) {
                                setData('name', placeholderName)
                            }
                        }}
                        placeholder={placeholderName}
                        name="name"
                        handleChange={onHandleChange}
                        value={data.name} className="w-full"
                    />
                </div>
            </div>

            <Button type="submit">Agregar</Button>
        </form>
    );
};

export default Create;
